import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_TRANSMITTALS_REFRESH: createSagaAction('LEAD_TRANSMITTALS_REFRESH'),

  LEAD_TRANSMITTAL_CREATE: createSagaAction('LEAD_TRANSMITTAL_CREATE'),
  LEAD_TRANSMITTAL_UPDATE: createSagaAction('LEAD_TRANSMITTAL_UPDATE'),
  LEAD_TRANSMITTAL_DELETE: createSagaAction('LEAD_TRANSMITTAL_DELETE'),

  GET_LEAD_TRANSMITTAL_DATA: createSagaAction('GET_LEAD_TRANSMITTAL_DATA'),

  UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT: createSagaAction('UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT'),
  GET_LEAD_TRANSMITTAL_ATTACHMENTS: createSagaAction('GET_LEAD_TRANSMITTAL_ATTACHMENTS'),
  UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_LEAD_TRANSMITTAL_ATTACHMENT: createSagaAction('DELETE_LEAD_TRANSMITTAL_ATTACHMENT')
}

// Action Creators
export const actions = {
  leadTransmittalsRefresh: ({ leadId }) => ({
    type: constants.LEAD_TRANSMITTALS_REFRESH.ACTION,
    leadId
  }),

  createLeadTransmittal: ({ leadId, content, sending, transmittalItems, transmitted, userId }) => ({
    type: constants.LEAD_TRANSMITTAL_CREATE.ACTION,
    leadId,
    content,
    sending,
    transmittalItems,
    transmitted,
    userId
  }),

  updateLeadTransmittal: ({
    leadId,
    transmittalId,
    content,
    sending,
    transmittalItems,
    transmitted,
    userId
  }) => ({
    type: constants.LEAD_TRANSMITTAL_UPDATE.ACTION,
    leadId,
    transmittalId,
    content,
    sending,
    transmittalItems,
    transmitted,
    userId
  }),

  deleteLeadTransmittal: ({ transmittalId, leadId }) => ({
    type: constants.LEAD_TRANSMITTAL_DELETE.ACTION,
    leadId,
    transmittalId
  }),

  getLeadTransmittalData: transmittalId => ({
    type: constants.GET_LEAD_TRANSMITTAL_DATA.ACTION,
    transmittalId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, transmittalId }) => ({
    type: constants.UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT.ACTION,
    formData,
    transmittalId
  }),

  getAttachments: ({ transmittalId }) => ({
    type: constants.GET_LEAD_TRANSMITTAL_ATTACHMENTS.ACTION,
    transmittalId
  }),

  updateAttachmentDescription: ({ attachmentId, currentId, description, userId }) => ({
    type: constants.UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    currentId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, currentId }) => ({
    type: constants.DELETE_LEAD_TRANSMITTAL_ATTACHMENT.ACTION,
    attachmentId,
    currentId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_TRANSMITTALS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_TRANSMITTALS_REFRESH.SUCCESS:
      return {
        ...state,
        leadTransmittals: action.payload
      }
    case constants.LEAD_TRANSMITTALS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.LEAD_TRANSMITTAL_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_TRANSMITTAL_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_TRANSMITTAL_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_LEAD_TRANSMITTAL_DATA.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_LEAD_TRANSMITTAL_DATA.SUCCESS:
      return {
        ...state,
        leadTransmittalData: action.payload
      }
    case constants.GET_LEAD_TRANSMITTAL_DATA.FAILED:
      return {
        error: action.message
      }

    // attachments
    case constants.UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_LEAD_TRANSMITTAL_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_LEAD_TRANSMITTAL_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_LEAD_TRANSMITTAL_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        transmittalAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_LEAD_TRANSMITTAL_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_LEAD_TRANSMITTAL_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_LEAD_TRANSMITTAL_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadTransmittalActions.js